import { customerPartnerFunctionsSlice } from "./customerPartnerFunctionsSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = customerPartnerFunctionsSlice;

export const QPARAMS_CHANGED = "customerPartnerFunctions/QParamsChanged";

export const setValidationErrors = actions.setValidationErrors;
const moduleUrl = '/api/appmasterdata/customer/partnerFunction'

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
